import { Logo } from "./marks/Logo";
import { Interactive } from "@/motion";

const LINKS = [
  { href: "#shop", label: "Shop" },
  { href: "#brand", label: "Brand" },
  { href: "#symbol", label: "Symbol" },
];

export function Nav() {
  return (
    <header className="nav">
      <div className="shell nav__inner">
        <a href="#top" className="nav__brand" aria-label="Path and Pace — home">
          <Logo className="nav__mark" alt="" />
          <span className="nav__word">Path &amp; Pace</span>
        </a>
        <nav aria-label="Primary">
          <ul className="nav__links">
            {LINKS.map((l) => (
              <li key={l.href}>
                {/* lift 0: nav links change opacity only, per skill §4 */}
                <Interactive as="a" href={l.href} className="nav__link" lift={0} scale={1}>
                  {l.label}
                </Interactive>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}
